<template>
  <v-container class="acesso-user">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form ref="form">
        <PageTitle
          main="Administração"
          icon="mdi-pencil-box-outline"
          sub="Acesso por usuário"
          home="/administracao"
        />
        <Form />
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Form from '../parametros/acessosuser'
export default {
  name: 'AcessoUser',
  components: { PageTitle, Form },
  data: () => ({

  })
}
</script>
